import React from 'react';
import PropTypes from 'prop-types';

function StepButtons({ handleNextStep, step }) {
  return (
    <div className="next-event-button-container">
      <div className="row">
        <div className="col-xs-6">
          {step === 0 ? (
            <div className="btn btn-primary prev-event-button" onClick={() => handleNextStep('intro')}>&lsaquo; Back</div>
          ) : (
            <div className="btn btn-primary prev-event-button" onClick={() => handleNextStep(step - 1)}>&lsaquo; Previous Event</div>
          )}
        </div>
        <div className="col-xs-6">
          <div className="btn btn-primary next-event-button" onClick={() => handleNextStep(step + 1)}>Next Event &rsaquo;</div>
        </div>
      </div>
    </div>
  );
}

StepButtons.propTypes = {
  handleNextStep: PropTypes.func,
  step: PropTypes.number, // this'll error out on intro
};

export default StepButtons;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/GuestFields/StepButtons.jsx